import Action from './baseActions';
import {ITag, ITagForCreation, ITagParent} from '../../models';

// Types

export enum TagsActionTypes {
  LOAD_TAGS = 'tags/load',
  LOADING_TAGS = 'tags/loading',
  LOADED_TAGS = 'tags/loaded',
  LOADING_TAGS_FAILED = 'tags/loading_failed',

  CLEAR_TAGS = 'tags/clear',

  CREATE_TAG = 'tag/create',
  CREATING_TAG = 'tag/creating',
  CREATED_TAG = 'tag/created',
  CREATING_TAG_FAILED = 'tag/creating_failed',

  UPDATE_TAG = 'tag/update',
  UPDATING_TAG = 'tag/updating',
  UPDATED_TAG = 'tag/updated',
  UPDATING_TAG_FAILED = 'tag/updating_failed',

  REMOVE_TAG = 'tag/remove',
  REMOVING_TAG = 'tag/removing',
  REMOVED_TAG = 'tag/removed',
  REMOVING_TAG_FAILED = 'tag/removing_failed'
}

// Interfaces

export interface LoadTagsAction extends Action {
  type: TagsActionTypes.LOAD_TAGS;
}

export interface LoadingTagsAction extends Action {
  type: TagsActionTypes.LOADING_TAGS;
}

export interface LoadedTagsAction extends Action {
  type: TagsActionTypes.LOADED_TAGS;
  payload: {
    tags: ITag[]
  };
}

export interface LoadingTagsFailedAction extends Action {
  type: TagsActionTypes.LOADING_TAGS_FAILED;
}

export interface ClearTagsAction extends Action {
  type: TagsActionTypes.CLEAR_TAGS;
}

export interface CreateTagAction extends Action {
  type: TagsActionTypes.CREATE_TAG;
  payload: {
    parent: ITagParent | null;
    tag: ITagForCreation;
  };
}

export interface CreatingTagAction extends Action {
  type: TagsActionTypes.CREATING_TAG;
}

export interface CreatedTagAction extends Action {
  type: TagsActionTypes.CREATED_TAG;
  payload: {
    parent: ITagParent | null;
    tag: ITag;
  };
}

export interface CreatingTagFailedAction extends Action {
  type: TagsActionTypes.CREATING_TAG_FAILED;
}

export interface UpdateTagAction extends Action {
  type: TagsActionTypes.UPDATE_TAG;
  payload: {
    uid: string;
    tag: Partial<ITag>;
  };
}

export interface UpdatingTagAction extends Action {
  type: TagsActionTypes.UPDATING_TAG;
}

export interface UpdatedTagAction extends Action {
  type: TagsActionTypes.UPDATED_TAG;
  payload: {
    uid: string;
    tag: ITag;
  };
}

export interface UpdatingTagFailedAction extends Action {
  type: TagsActionTypes.UPDATING_TAG_FAILED;
}

export interface RemoveTagAction extends Action {
  type: TagsActionTypes.REMOVE_TAG;
  payload: {
    parent: ITagParent | null;
    uid: string;
  };
}

export interface RemovingTagAction extends Action {
  type: TagsActionTypes.REMOVING_TAG;
  payload: {
    parent: ITagParent | null;
    uid: string;
  };
}

export interface RemovedTagAction extends Action {
  type: TagsActionTypes.REMOVED_TAG;
  payload: {
    parent: ITagParent | null;
    uid: string;
  };
}

export interface RemovingTagFailedAction extends Action {
  type: TagsActionTypes.REMOVING_TAG_FAILED;
}

// Functions

export function loadTags(): LoadTagsAction {
  return {
    type: TagsActionTypes.LOAD_TAGS
  }
}

export function loadingTags(): LoadingTagsAction {
  return {
    type: TagsActionTypes.LOADING_TAGS
  }
}

export function loadedTags(tags: ITag[]): LoadedTagsAction {
  return {
    type: TagsActionTypes.LOADED_TAGS,
    payload: {
      tags
    }
  }
}

export function loadingTagsFailed(): LoadingTagsFailedAction {
  return {
    type: TagsActionTypes.LOADING_TAGS_FAILED
  }
}

export function clearTags(): ClearTagsAction {
  return {
    type: TagsActionTypes.CLEAR_TAGS
  }
}

export function createTag(tag: ITagForCreation, parent: ITagParent | null = null): CreateTagAction {
  return {
    type: TagsActionTypes.CREATE_TAG,
    payload: {tag, parent}
  }
}

export function creatingTag(): CreatingTagAction {
  return {
    type: TagsActionTypes.CREATING_TAG,
  }
}

export function createdTag(tag: ITag, parent: ITagParent | null): CreatedTagAction {
  return {
    type: TagsActionTypes.CREATED_TAG,
    payload: {tag, parent}
  }
}

export function creatingTagFailed(): CreatingTagFailedAction {
  return {
    type: TagsActionTypes.CREATING_TAG_FAILED
  }
}

export function updateTag(uid: string, tag: Partial<ITag>): UpdateTagAction {
  return {
    type: TagsActionTypes.UPDATE_TAG,
    payload: {uid, tag}
  }
}

export function updatingTag(): UpdatingTagAction {
  return {
    type: TagsActionTypes.UPDATING_TAG
  }
}

export function updatedTag(uid: string, tag: ITag): UpdatedTagAction {
  return {
    type: TagsActionTypes.UPDATED_TAG,
    payload: {uid, tag}
  }
}

export function updatingTagFailed(): UpdatingTagFailedAction {
  return {
    type: TagsActionTypes.UPDATING_TAG_FAILED
  }
}

export function removeTag(uid: string, parent: ITagParent | null = null): RemoveTagAction {
  return {
    type: TagsActionTypes.REMOVE_TAG,
    payload: {uid, parent}
  }
}

export function removingTag(uid: string, parent: ITagParent | null = null): RemovingTagAction {
  return {
    type: TagsActionTypes.REMOVING_TAG,
    payload: {uid, parent}
  }
}

export function removedTag(uid: string, parent: ITagParent | null = null): RemovedTagAction {
  return {
    type: TagsActionTypes.REMOVED_TAG,
    payload: {uid, parent}
  }
}

export function removingTagFailed(): RemovingTagFailedAction {
  return {
    type: TagsActionTypes.REMOVING_TAG_FAILED
  }
}

export type TagsAction =
  LoadTagsAction |
  LoadingTagsAction |
  LoadedTagsAction |
  LoadingTagsFailedAction |
  ClearTagsAction |
  CreateTagAction |
  CreatingTagAction |
  CreatedTagAction |
  CreatingTagFailedAction |
  UpdateTagAction |
  UpdatingTagAction |
  UpdatedTagAction |
  UpdatingTagFailedAction |
  RemoveTagAction |
  RemovingTagAction |
  RemovedTagAction |
  RemovingTagFailedAction;
